export interface Irop {
  iropType: boolean;
}
